import React, {Component} from 'react';
import { Field, reduxForm } from 'redux-form';

class EditStudentForm extends Component {
  render() {
    const { handleSubmit, isSending } = this.props;
    return (
      <form className="edit-student-form"
        onSubmit={handleSubmit}
      >
      <div>
         <p>
            <label>Index</label>
            <Field
              name="index"
              component="input"
            />
        </p>
         <p>
            <label>Imię</label>
            <Field
              name="firstName"
              component="input"
            />
        </p>
         <p>
            <label>Nazwisko</label>
            <Field
              name="surname"
              component="input"
            />
        </p>
         <p>
            <label>E-mail</label>
            <Field
              name="mail"
              component="input"
            />
        </p>
         <p>
            <label>Z W8</label>
            <Field
              name="isIzet"
              component="input"
            />
        </p>
         {/* <p>
            <label>Płeć</label>
            <Field
              name="sex"
              component="input"
            />
        </p> */}
         {/* <p>
            <label>Rozmiar koszulki</label>
            <Field
              name="tShirtSize"
              component="input"
            />
        </p> */}
         <p>
            <label>Status</label>
            <Field
              name="statusStudent"
              component="input"
            />
        </p>
         <p>
            <label>Funkcja</label>
            <Field
              name="studentFunction"
              component="input"
            />
        </p>
        </div>
        <div>
         <p>
            <label>Płatność</label>
            <Field
              name="paymentsInfo"
              component="input"
            />
        </p>
        {/* <p>
            <label>Dieta</label>
             <Field
               name="diet"
               component="input"
             />
            </p> */}
         {/* <p>
            <label>Transport</label>
            <Field
              name="transport"
              component="input"
            />
        </p> */}
         {/* <p>
            <label>ICE numer</label>
            <Field
              name="ice"
              component="input"
            />
        </p> */}
         {/* <p>
            <label>ICE imie nazwisko</label>
            <Field
              name="icePerson"
              component="input"
            />
        </p> */}
         {/* <p>
            <label>nr Domku</label>
             <Field
                 name="room"
                 component="input"
             />
         </p> */}
         <p>
            <label>Imię zgłaszającego</label>
             <Field
                 name="partnerOf.firstName"
                 component="input"
             />
         </p>
         <p>
            <label>Nazwisko zgłaszającego</label>
             <Field
                 name="partnerOf.surname"
                 component="input"
             />
         </p>
         <p>
            <label>Imię partnera</label>
             <Field
                 name="hasPartner.firstName"
                 component="input"
             />
         </p>
         <p>
            <label>Nazwisko partnera</label>
             <Field
                 name="hasPartner.surname"
                 component="input"
             />
         </p>

        </div>
        <div>
          <button disabled={isSending}>Zaktualizuj</button>
        </div>
      </form>
    )
  }
};
// {
//     "_id": {
//         "$oid": "5ab6c7c64e2fc8139d713b14"
//     },
//     "index": "238487",
//     "firstName": "Aleksandra",
//     "surname": "Waszkowski",
//     "mail": "Aleksandra.Waszkowski@gmail.com",
//     "department": "w1",
//     "sex": "mezczyzna",
//     "statusStudent": null,
//     "studentFunction": "uczestnik",
//     "paymentsInfo": null,
//     "transport": null,
//     "room": null,
//     "statement": null,
//     "tShirtSize": "xl",
//     "preferDepartures": "17:00",
//     "ice": {},
//     "receivedMail": null,
//     "recordData": 1521928128996
// }
export default reduxForm({
    form: 'editStudent'
  })(EditStudentForm);



// WEBPACK FOOTER //
// ./src/modules/Admin/components/EditStudentForm.js